import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import Header from '../Example/components/Header';
import Copyright from '../../components/Copyright';
import CustomTab from '../../CustomTab';

import { AppContext, useApp } from '../../contexts/AppContext';

import "./styles.scss"
import { showToast, startLoading, stopLoading } from '../../services/common-service';
import NewTicketForm from './components/NewTicketForm';
import BlipPortalToastTypes from '../../constants/blip-portal-toast-types';

const PAGE_ICON = 'ticket';
const BLANK = '_blank';

const Ticket = () => {
    const { t, i18n } = useContext(AppContext)

    const history = useHistory();

    const [customTab, setCustomTab] = useState(null)

    function useQuery() {
        const { search } = useLocation();
        return new URLSearchParams(search);
    }

    const query = useQuery()

    return (
        <div className="flex" style={{ height: "100vh", overflowX: "auto", backgroundColor: query.get("backgroundColor") }}>
            <div className="home-container ph1 ph4-m ph5-ns pb5 relative" style={{ flex: 1 }}>
                {query.get("admin") != "true" && <Header title={t('menu.goBack')} onClick={() => history.push('/')} />}

                <NewTicketForm
                    chooseTenant={query.get("admin") == "true"}
                />

                {/* {(!ticketOpened || (ticketOpened && config?.showCopyrightWithTicketOpen)) &&
                    <Copyright />
                } */}
            </div>

            <CustomTab
                opened={customTab != null}
                setCustomTab={setCustomTab}
                {...customTab}
            />
        </div>
    );
};

Ticket.propTypes = {};

export default Ticket;
